<template>
  <div>
    <Map ref="map" :center="center" :options="{ zoomSnap: 1 }">
      <template v-slot:marker>
        <v-marker-cluster ref="myCluster">
          <l-marker
            v-for="marker of markers"
            data-cy="marker"
            :key="marker.id"
            :name="marker.id"
            :lat-lng="marker.location"
            :options="{ id: marker.id }"
            :icon="marker.icon"
            :ref="marker.id"
            @add="handleEvent"
          >
            <popup ref="popup">
              <template slot="content">
                <div @click="markerClicked(marker.id)">
                  <div class="popup-container" data-cy="popup-content">
                    <p class="text-uppercase text-center">
                      {{
                        `Platine ${
                          marker.friendlyName
                            ? marker.friendlyName
                            : marker.reference
                        }`
                      }}
                    </p>
                    <i class="fas fa-arrow-circle-right navbar-text-color"></i>
                  </div>
                  <div style="border-bottom: 1px black solid;">
                    {{ marker.avoidedCO2 }} Kg d'émissions de CO2 évitées
                  </div>
                  <div
                    v-for="formatedAlert of marker.alerts"
                    :key="formatedAlert._id"
                  >
                    {{ formatedAlert.ruleName }}
                    <span
                      v-if="
                        formatedAlert.collection === 'devices' &&
                          formatedAlert.assetMeasureName != null
                      "
                    >
                      ({{ formatedAlert.assetMeasureName }})
                    </span>
                  </div>
                </div>
              </template>
            </popup> </l-marker
          >émission
        </v-marker-cluster>
      </template>
    </Map>
    <!-- <div class="btn-co2">Tenant Title</div> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';
import L from 'leaflet';
import Map from '@/components/Map.vue';
import Popup from '@/components/Popup.vue';
import { LMarker } from 'vue2-leaflet';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';

export default {
  name: 'home',
  components: {
    Map,
    LMarker,
    Popup,
    'v-marker-cluster': Vue2LeafletMarkerCluster
  },
  computed: {
    ...mapGetters('auth', ['currentLoggedinUser', 'currentTenant'])
  },
  watch: {
    'currentTenant.index'(newValue) {
      this.refresh();
    }
  },
  async mounted() {
    await this.refresh();
    const tenant = this.currentTenant.index;
    await this.$kuzzle.realtime.subscribe(tenant, 'assets', {}, async () => {
      await this.refresh();
    });
  },
  data() {
    return {
      markers: [],
      center: [51.504, -0.159]
    };
  },
  methods: {
    async refresh() {
      const tenant = this.currentTenant.index;
      const { result } = await this.$kuzzle.query({
        index: tenant,
        engineId: tenant,
        controller: 'device-manager/assets',
        action: 'search',
        body: {}
      });

      this.markers = [];

      for (const asset of result.hits) {
        const geolocation = asset._source.metadata.geolocation;

        if (!geolocation) {
          continue;
        }

        const lat = geolocation.lat;
        const lng = geolocation.lon;
        const friendlyNameMetadata = asset._source.metadata.friendlyName;

        let avoidedCO2 = 0;

        for (const [name, metadata] of Object.entries(asset._source.metadata)) {
          if (!name.startsWith('frameChannel')) {
            continue;
          }

          if (!metadata.avoidedCO2) {
            continue;
          }
          avoidedCO2 += metadata.avoidedCO2;
        }

        avoidedCO2 += await this.getPreviousAvoidedCo2(tenant, asset._id);

        const alerts = await this.getAlerts(tenant, asset);
        const color = this.getMarkerColor(alerts);

        const formatedAlerts = [];

        for (const alert of alerts) {
          const formatedAlert = {
            _id: alert._id,
            ruleName: alert._source.alertRule._source.name,
            collection: alert._source.document.collection
          };

          if (alert._source.document.collection === 'devices') {
            const linkedDevice = asset._source.linkedDevices.find(
              link => link._id === alert._source.document._id
            );

            if (!linkedDevice) {
              continue;
            }

            const measureNames = linkedDevice.measureNames.find(
              measureNames => measureNames.device === 'channel'
            );

            formatedAlert.assetMeasureName = measureNames
              ? measureNames.asset
              : null;
          }
          formatedAlerts.push(formatedAlert);
        }

        this.markers.push({
          id: asset._id,
          model: asset._source.model,
          reference: asset._source.reference,
          friendlyName: friendlyNameMetadata
            ? friendlyNameMetadata
            : asset._source.reference,
          avoidedCO2: avoidedCO2.toFixed(2),
          type: asset._source.type,
          location: { lat, lng },
          alerts: formatedAlerts,
          icon: new L.divIcon({
            html: `<i class="fa fa-map-marker fa-3x" style="color:${color}"></i>`,
            className: 'heartIcon',
            shadowUrl,
            iconSize: [20, 36],
            iconAnchor: [10, 36],
            popupAnchor: [1, -34],
            interactive: true
          })
        });
      }

      if (this.markers.length) {
        const { lat, lng } = this.markers[0].location;

        this.center = [lat, lng];
      }
    },
    async getPreviousAvoidedCo2(tenantIndex, assetId) {
      const query = {
        and: [
          { equals: { 'asset._id': assetId } },
          { equals: { type: 'avoidedCO2' } }
        ]
      };

      const aggregations = {
        avoidedCO2: {
          sum: { field: 'values.avoidedCO2' }
        }
      };

      const result = await this.$kuzzle.document.search(
        tenantIndex,
        'measures',
        { query, aggregations },
        {
          lang: 'koncorde',
          size: 0
        }
      );

      return result.aggregations.avoidedCO2.value;
    },
    async getAlerts(tenantIndex, asset) {
      const query = {
        or: [
          {
            and: [
              {
                equals: { 'document._id': asset._id }
              },
              {
                equals: { status: 'pending' }
              }
            ]
          }
        ]
      };

      for (const linkedDevice of asset._source.linkedDevices) {
        query.or.push({
          and: [
            {
              equals: { 'document._id': linkedDevice._id }
            },
            {
              equals: { status: 'pending' }
            }
          ]
        });
      }

      const result = await this.$kuzzle.document.search(
        tenantIndex,
        'alerts',
        { query },
        { lang: 'koncorde' }
      );

      return result.hits;
    },
    markerClicked(assetId) {
      const params = { assetId };
      this.$router.push({ name: 'asset', params });
    },
    getMarkerColor(alerts) {
      if (alerts.find(alert => alert._source.severity === 'critical')) {
        return 'red';
      }

      if (alerts.find(alert => alert._source.severity === 'warning')) {
        return 'orange';
      }

      return 'green';
    },
    handleEvent(event) {
      // only handle mouseover on desktop
      if (window.innerWidth >= 768) {
        this.$nextTick(() => {
          event.target.on('mouseover', () => {
            event.target.openPopup();
          });
          event.target.on('mouseout', () => {
            setTimeout(() => {
              event.target.closePopup();
            }, 5000);
          });
        });
      }
    }
  }
};
</script>

<style scoped>
.btn-co2 {
  width: 30%;
  background: #94c62a;
  z-index: 2000;
  height: 40px;
  position: absolute;
  bottom: 20px;
  box-shadow: 1px 3px rgba(0, 0, 0, 0.3);
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  cursor: pointer;
  color: white;
  font-size: 18px;
  padding: 6px 0;
  text-align: center;
}

.btn-view-assets {
  width: 100%;
  background: #94c62a;
  height: 30px;
  bottom: 20px;
  cursor: pointer;
  color: white;
  font-size: 12px;
  text-align: center;
  border: none;
  border-radius: 3px;
}

.popup-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 25px;
}

::v-deep .leaflet-popup-close-button {
  display: none;
}

::v-deep .leaflet-popup-content {
  margin: 10px;
  cursor: pointer;
}

@media only screen and (max-width: 600px) {
  .btn-co2 {
    width: 80%;
  }
}
</style>

<style lang="sass">
@import "~leaflet.markercluster/dist/MarkerCluster.css"
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css"
</style>
